import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IconMinus from 'components/icons/iconMinus';
import IconPlus from 'components/icons/iconPlus';
import IconTrash from 'components/icons/IconTrash';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import { colorGrayOverlay, colorGray } from 'styles/layout/colors';

const MAX_ITEMS = 16;

const Quantity = ({
  issue = null,
  maxQuantity = MAX_ITEMS,
  minQuantity = 0,
  onAddItem,
  onAddItemMaxQuantity = () => {},
  onRemoveItem,
  onRemoveItemMinQuantity = () => {},
  quantity,
  unavailableFabric = false,
  variant,
}) => {
  const isAtMinQuantity = quantity === minQuantity;
  const hasMaxQuantity = quantity >= maxQuantity;

  return (
    <div
      className={classNames('flex', {
        'mb-[.2rem]': variant === 'ModularItem',
      })}
    >
      <button
        type="button"
        className={classNames(
          'flex items-center justify-center bg-white border border-solid border-gray-light6 rounded-full h-8 w-8 hover:border-brand hover:cursor-pointer',
          {
            'bg-gray-light6 hover:border-gray-light6 hover:cursor-default': unavailableFabric,
          }
        )}
        onClick={isAtMinQuantity ? onRemoveItemMinQuantity : onRemoveItem}
        aria-label={
          quantity <= 1 || isAtMinQuantity || issue
            ? 'Remove product from cart'
            : 'Remove one of these products from cart'
        }
        disabled={unavailableFabric}
        data-xc="cart-quantity-decrease"
      >
        {quantity <= 1 || isAtMinQuantity || issue ? (
          <IconTrash width="16" height="16" color={colorGray} />
        ) : (
          <IconMinus width="18" height="18" color={colorGray} />
        )}
      </button>

      <div
        className="flex items-center justify-center text-base font-bold text-gray-light1 h-8 px-2 py-0"
        role="alert"
        data-xc="cart-quantity-value"
      >
        <VisuallyHidden>Quantity </VisuallyHidden>
        {quantity}
      </div>

      {!issue && (
        <button
          type="button"
          className={classNames(
            'flex items-center justify-center bg-white border border-solid border-gray-light6 rounded-full h-8 w-8 hover:border-brand hover:cursor-pointer',
            {
              'bg-gray-light6 hover:border-gray-light6 hover:cursor-default':
                hasMaxQuantity || unavailableFabric,
            }
          )}
          onClick={hasMaxQuantity ? onAddItemMaxQuantity : onAddItem}
          aria-label="Add one of these products to cart"
          disabled={unavailableFabric || hasMaxQuantity}
          data-xc="cart-quantity-increase"
        >
          <IconPlus
            width="18"
            height="18"
            color={hasMaxQuantity ? colorGrayOverlay : colorGray}
          />
        </button>
      )}
    </div>
  );
};

Quantity.propTypes = {
  maxQuantity: PropTypes.number,
  minQuantity: PropTypes.number,
  onAddItem: PropTypes.func.isRequired,
  onAddItemMaxQuantity: PropTypes.func,
  onRemoveItem: PropTypes.func.isRequired,
  onRemoveItemMinQuantity: PropTypes.func,
  quantity: PropTypes.number.isRequired,
  issue: PropTypes.string,
  unavailableFabric: PropTypes.bool,
  variant: PropTypes.oneOf(['ModularItem']),
};

export default Quantity;
